import {environment} from 'src/environments/environment';

export interface Country {
  name: CountryName;
  age: number;
}

export enum CountryName {
  UTO = 'UTO',
  AFG = 'AFG',
  AGO = 'AGO',
  ALB = 'ALB',
  AND = 'AND',
  ARE = 'ARE',
  ARG = 'ARG',
  ARM = 'ARM',
  ATG = 'ATG',
  AUS = 'AUS',
  AUT = 'AUT',
  AZE = 'AZE',
  BDI = 'BDI',
  BEL = 'BEL',
  BEN = 'BEN',
  BFA = 'BFA',
  BGD = 'BGD',
  BGR = 'BGR',
  BHR = 'BHR',
  BHS = 'BHS',
  BIH = 'BIH',
  BLR = 'BLR',
  BLZ = 'BLZ',
  BOL = 'BOL',
  BRA = 'BRA',
  BRB = 'BRB',
  BRN = 'BRN',
  BTN = 'BTN',
  BWA = 'BWA',
  CAF = 'CAF',
  CAN = 'CAN',
  CHE = 'CHE',
  CHL = 'CHL',
  CHN = 'CHN',
  CIV = 'CIV',
  CMR = 'CMR',
  COD = 'COD',
  COG = 'COG',
  COL = 'COL',
  COM = 'COM',
  CPV = 'CPV',
  CRI = 'CRI',
  CUB = 'CUB',
  CYP = 'CYP',
  CZE = 'CZE',
  DEU = 'DEU',
  DJI = 'DJI',
  DMA = 'DMA',
  DNK = 'DNK',
  DOM = 'DOM',
  DZA = 'DZA',
  ECU = 'ECU',
  EGY = 'EGY',
  ERI = 'ERI',
  ESP = 'ESP',
  EST = 'EST',
  ETH = 'ETH',
  FIN = 'FIN',
  FJI = 'FJI',
  FRA = 'FRA',
  FSM = 'FSM',
  GAB = 'GAB',
  GBR = 'GBR',
  GEO = 'GEO',
  GHA = 'GHA',
  GIN = 'GIN',
  GMB = 'GMB',
  GNB = 'GNB',
  GNQ = 'GNQ',
  GRC = 'GRC',
  GRD = 'GRD',
  GTM = 'GTM',
  GUY = 'GUY',
  HND = 'HND',
  HRV = 'HRV',
  HTI = 'HTI',
  HUN = 'HUN',
  IDN = 'IDN',
  IND = 'IND',
  IRL = 'IRL',
  IRN = 'IRN',
  IRQ = 'IRQ',
  ISL = 'ISL',
  ISR = 'ISR',
  ITA = 'ITA',
  JAM = 'JAM',
  JOR = 'JOR',
  JPN = 'JPN',
  KAZ = 'KAZ',
  KEN = 'KEN',
  KGZ = 'KGZ',
  KHM = 'KHM',
  KIR = 'KIR',
  KNA = 'KNA',
  KOR = 'KOR',
  KWT = 'KWT',
  LAO = 'LAO',
  LBN = 'LBN',
  LBR = 'LBR',
  LBY = 'LBY',
  LCA = 'LCA',
  LIE = 'LIE',
  LKA = 'LKA',
  LSO = 'LSO',
  LTU = 'LTU',
  LUX = 'LUX',
  LVA = 'LVA',
  MAR = 'MAR',
  MCO = 'MCO',
  MDA = 'MDA',
  MDG = 'MDG',
  MDV = 'MDV',
  MEX = 'MEX',
  MHL = 'MHL',
  MKD = 'MKD',
  MLI = 'MLI',
  MLT = 'MLT',
  MMR = 'MMR',
  MNE = 'MNE',
  MNG = 'MNG',
  MOZ = 'MOZ',
  MRT = 'MRT',
  MUS = 'MUS',
  MWI = 'MWI',
  MYS = 'MYS',
  NAM = 'NAM',
  NER = 'NER',
  NGA = 'NGA',
  NIC = 'NIC',
  NLD = 'NLD',
  NOR = 'NOR',
  NPL = 'NPL',
  NRU = 'NRU',
  NZL = 'NZL',
  OMN = 'OMN',
  PAK = 'PAK',
  PAN = 'PAN',
  PER = 'PER',
  PHL = 'PHL',
  PLW = 'PLW',
  PNG = 'PNG',
  POL = 'POL',
  PRK = 'PRK',
  PRT = 'PRT',
  PRY = 'PRY',
  PSE = 'PSE',
  QAT = 'QAT',
  ROU = 'ROU',
  RUS = 'RUS',
  RWA = 'RWA',
  SAU = 'SAU',
  SDN = 'SDN',
  SEN = 'SEN',
  SGP = 'SGP',
  SLB = 'SLB',
  SLE = 'SLE',
  SLV = 'SLV',
  SMR = 'SMR',
  SOM = 'SOM',
  SRB = 'SRB',
  SSD = 'SSD',
  STP = 'STP',
  SUR = 'SUR',
  SVK = 'SVK',
  SVN = 'SVN',
  SWE = 'SWE',
  SWZ = 'SWZ',
  SYC = 'SYC',
  SYR = 'SYR',
  TCD = 'TCD',
  TGO = 'TGO',
  THA = 'THA',
  TJK = 'TJK',
  TKM = 'TKM',
  TLS = 'TLS',
  TON = 'TON',
  TTO = 'TTO',
  TUN = 'TUN',
  TUR = 'TUR',
  TUV = 'TUV',
  TWN = 'TWN',
  TZA = 'TZA',
  UGA = 'UGA',
  UKR = 'UKR',
  URY = 'URY',
  USA = 'USA',
  UZB = 'UZB',
  VAT = 'VAT',
  VCT = 'VCT',
  VEN = 'VEN',
  VNM = 'VNM',
  VUT = 'VUT',
  WSM = 'WSM',
  YEM = 'YEM',
  ZAF = 'ZAF',
  ZMB = 'ZMB',
  ZWE = 'ZWE',
  CIV_ADMIN = 'CIV_ADMIN',
  GMB_ADMIN = 'GMB_ADMIN',
  LUX_ADMIN = 'LUX_ADMIN',
  ZWE_ADMIN = 'ZWE_ADMIN',
  KEN_ADMIN = 'KEN_ADMIN',
  UTO_ADMIN = 'UTO_ADMIN'
}

const countries: Country[] = [
  {name: CountryName.UTO, age: 18},
  {name: CountryName.AFG, age: 18},
  {name: CountryName.AGO, age: 18},
  {name: CountryName.ALB, age: 18},
  {name: CountryName.AND, age: 18},
  {name: CountryName.ARE, age: 21},
  {name: CountryName.ARG, age: 18},
  {name: CountryName.ARM, age: 18},
  {name: CountryName.ATG, age: 18},
  {name: CountryName.AUS, age: 18},
  {name: CountryName.AUT, age: 18},
  {name: CountryName.AZE, age: 18},
  {name: CountryName.BDI, age: 18},
  {name: CountryName.BEL, age: 18},
  {name: CountryName.BEN, age: 18},
  {name: CountryName.BFA, age: 18},
  {name: CountryName.BGD, age: 18},
  {name: CountryName.BGR, age: 18},
  {name: CountryName.BHR, age: 18},
  {name: CountryName.BHS, age: 18},
  {name: CountryName.BIH, age: 18},
  {name: CountryName.BLR, age: 18},
  {name: CountryName.BLZ, age: 18},
  {name: CountryName.BOL, age: 18},
  {name: CountryName.BRA, age: 18},
  {name: CountryName.BRB, age: 18},
  {name: CountryName.BRN, age: 18},
  {name: CountryName.BTN, age: 18},
  {name: CountryName.BWA, age: 18},
  {name: CountryName.CAF, age: 18},
  {name: CountryName.CAN, age: 18},
  {name: CountryName.CHE, age: 18},
  {name: CountryName.CHL, age: 18},
  {name: CountryName.CHN, age: 18},
  {name: CountryName.CIV, age: 21},
  {name: CountryName.CMR, age: 21},
  {name: CountryName.COD, age: 18},
  {name: CountryName.COG, age: 18},
  {name: CountryName.COL, age: 18},
  {name: CountryName.COM, age: 18},
  {name: CountryName.CPV, age: 18},
  {name: CountryName.CRI, age: 18},
  {name: CountryName.CUB, age: 16},
  {name: CountryName.CYP, age: 18},
  {name: CountryName.CZE, age: 18},
  {name: CountryName.DEU, age: 18},
  {name: CountryName.DJI, age: 18},
  {name: CountryName.DMA, age: 18},
  {name: CountryName.DNK, age: 18},
  {name: CountryName.DOM, age: 18},
  {name: CountryName.DZA, age: 19},
  {name: CountryName.ECU, age: 18},
  {name: CountryName.EGY, age: 21},
  {name: CountryName.ERI, age: 18},
  {name: CountryName.ESP, age: 18},
  {name: CountryName.EST, age: 18},
  {name: CountryName.ETH, age: 18},
  {name: CountryName.FIN, age: 18},
  {name: CountryName.FJI, age: 18},
  {name: CountryName.FRA, age: 18},
  {name: CountryName.FSM, age: 18},
  {name: CountryName.GAB, age: 21},
  {name: CountryName.GBR, age: 18},
  {name: CountryName.GEO, age: 18},
  {name: CountryName.GHA, age: 18},
  {name: CountryName.GIN, age: 18},
  {name: CountryName.GMB, age: 18},
  {name: CountryName.GNB, age: 18},
  {name: CountryName.GNQ, age: 18},
  {name: CountryName.GRC, age: 18},
  {name: CountryName.GRD, age: 21},
  {name: CountryName.GTM, age: 18},
  {name: CountryName.GUY, age: 18},
  {name: CountryName.HND, age: 21},
  {name: CountryName.HRV, age: 18},
  {name: CountryName.HTI, age: 18},
  {name: CountryName.HUN, age: 18},
  {name: CountryName.IDN, age: 18},
  {name: CountryName.IND, age: 18},
  {name: CountryName.IRL, age: 18},
  {name: CountryName.IRN, age: 18},
  {name: CountryName.IRQ, age: 18},
  {name: CountryName.ISL, age: 18},
  {name: CountryName.ISR, age: 18},
  {name: CountryName.ITA, age: 18},
  {name: CountryName.JAM, age: 18},
  {name: CountryName.JOR, age: 18},
  {name: CountryName.JPN, age: 18},
  {name: CountryName.KAZ, age: 18},
  {name: CountryName.KEN, age: 18},
  {name: CountryName.KGZ, age: 18},
  {name: CountryName.KHM, age: 18},
  {name: CountryName.KIR, age: 18},
  {name: CountryName.KNA, age: 18},
  {name: CountryName.KOR, age: 19},
  {name: CountryName.KWT, age: 21},
  {name: CountryName.LAO, age: 18},
  {name: CountryName.LBN, age: 18},
  {name: CountryName.LBR, age: 18},
  {name: CountryName.LBY, age: 18},
  {name: CountryName.LCA, age: 18},
  {name: CountryName.LIE, age: 18},
  {name: CountryName.LKA, age: 18},
  {name: CountryName.LSO, age: 21},
  {name: CountryName.LTU, age: 18},
  {name: CountryName.LUX, age: 18},
  {name: CountryName.LVA, age: 18},
  {name: CountryName.MAR, age: 18},
  {name: CountryName.MCO, age: 18},
  {name: CountryName.MDA, age: 18},
  {name: CountryName.MDG, age: 21},
  {name: CountryName.MDV, age: 18},
  {name: CountryName.MEX, age: 18},
  {name: CountryName.MHL, age: 18},
  {name: CountryName.MKD, age: 18},
  {name: CountryName.MLI, age: 18},
  {name: CountryName.MLT, age: 18},
  {name: CountryName.MMR, age: 16},
  {name: CountryName.MNE, age: 18},
  {name: CountryName.MNG, age: 18},
  {name: CountryName.MOZ, age: 21},
  {name: CountryName.MRT, age: 18},
  {name: CountryName.MUS, age: 18},
  {name: CountryName.MWI, age: 18},
  {name: CountryName.MYS, age: 18},
  {name: CountryName.NAM, age: 18},
  {name: CountryName.NER, age: 21},
  {name: CountryName.NGA, age: 18},
  {name: CountryName.NIC, age: 18},
  {name: CountryName.NLD, age: 18},
  {name: CountryName.NOR, age: 18},
  {name: CountryName.NPL, age: 18},
  {name: CountryName.NRU, age: 18},
  {name: CountryName.NZL, age: 20},
  {name: CountryName.OMN, age: 18},
  {name: CountryName.PAK, age: 18},
  {name: CountryName.PAN, age: 18},
  {name: CountryName.PER, age: 18},
  {name: CountryName.PHL, age: 18},
  {name: CountryName.PLW, age: 18},
  {name: CountryName.PNG, age: 18},
  {name: CountryName.POL, age: 18},
  {name: CountryName.PRK, age: 17},
  {name: CountryName.PRT, age: 18},
  {name: CountryName.PRY, age: 18},
  {name: CountryName.PSE, age: 18},
  {name: CountryName.QAT, age: 18},
  {name: CountryName.ROU, age: 18},
  {name: CountryName.RUS, age: 18},
  {name: CountryName.RWA, age: 18},
  {name: CountryName.SAU, age: 18},
  {name: CountryName.SDN, age: 18},
  {name: CountryName.SEN, age: 18},
  {name: CountryName.SGP, age: 21},
  {name: CountryName.SLB, age: 18},
  {name: CountryName.SLE, age: 18},
  {name: CountryName.SLV, age: 18},
  {name: CountryName.SMR, age: 18},
  {name: CountryName.SOM, age: 18},
  {name: CountryName.SRB, age: 18},
  {name: CountryName.SSD, age: 18},
  {name: CountryName.STP, age: 18},
  {name: CountryName.SUR, age: 18},
  {name: CountryName.SVK, age: 18},
  {name: CountryName.SVN, age: 18},
  {name: CountryName.SWE, age: 18},
  {name: CountryName.SWZ, age: 21},
  {name: CountryName.SYC, age: 18},
  {name: CountryName.SYR, age: 18},
  {name: CountryName.TCD, age: 21},
  {name: CountryName.TGO, age: 18},
  {name: CountryName.THA, age: 20},
  {name: CountryName.TJK, age: 18},
  {name: CountryName.TKM, age: 18},
  {name: CountryName.TLS, age: 17},
  {name: CountryName.TON, age: 18},
  {name: CountryName.TTO, age: 18},
  {name: CountryName.TUN, age: 18},
  {name: CountryName.TUR, age: 18},
  {name: CountryName.TUV, age: 18},
  {name: CountryName.TWN, age: 18},
  {name: CountryName.TZA, age: 18},
  {name: CountryName.UGA, age: 18},
  {name: CountryName.UKR, age: 18},
  {name: CountryName.URY, age: 18},
  {name: CountryName.USA, age: 18},
  {name: CountryName.UZB, age: 18},
  {name: CountryName.VAT, age: 18},
  {name: CountryName.VCT, age: 18},
  {name: CountryName.VEN, age: 18},
  {name: CountryName.VNM, age: 16},
  {name: CountryName.VUT, age: 18},
  {name: CountryName.WSM, age: 21},
  {name: CountryName.YEM, age: 15},
  {name: CountryName.ZAF, age: 18},
  {name: CountryName.ZMB, age: 21},
  {name: CountryName.ZWE, age: 18},
  {
    name: CountryName.CIV_ADMIN,
    age: 21
  },
  {
    name: CountryName.LUX_ADMIN,
    age: 18
  },
  {
    name: CountryName.ZWE_ADMIN,
    age: 18
  },
  {
    name: CountryName.GMB_ADMIN,
    age: 18
  },
  {
    name: CountryName.KEN_ADMIN,
    age: 18
  },
  {
    name: CountryName.UTO_ADMIN,
    age: 18
  }
];

export const envCountries = () => countries
  .filter(country => !environment.countryExcludes.includes(country.name))
  .sort((a, b) => environment.sortCountries(a.name, b.name));

export const countriesSO = () => countries
  .filter((country) => !country.name.includes('_ADMIN'))
  .map((country) => ({
    value: country.name,
    name: 'form.DYN.country.' + country.name
  }))
  .filter(country => !environment.countryExcludes.includes(country.value))
  .sort((a, b) => environment.sortCountries(a.value, b.value));
